import { render, staticRenderFns } from "./DigitalPromoCard.vue?vue&type=template&id=0bb3ba70&"
import script from "./DigitalPromoCard.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb3ba70')) {
      api.createRecord('0bb3ba70', component.options)
    } else {
      api.reload('0bb3ba70', component.options)
    }
    module.hot.accept("./DigitalPromoCard.vue?vue&type=template&id=0bb3ba70&", function () {
      api.rerender('0bb3ba70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/DigitalPromoCard.vue"
export default component.exports